// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"641":"472a01aa","879":"12f765e0"}[chunkId] + ".chunk.js";
};